/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_top_ups_modal_total_to_pay_label = /** @type {(inputs: {}) => string} */ () => {
	return `Total a Pagar`
};

const en_top_ups_modal_total_to_pay_label = /** @type {(inputs: {}) => string} */ () => {
	return `Total to Pay`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const top_ups_modal_total_to_pay_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.top_ups_modal_total_to_pay_label(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("top_ups_modal_total_to_pay_label", locale)
	if (locale === "es") return es_top_ups_modal_total_to_pay_label(inputs)
	return en_top_ups_modal_total_to_pay_label(inputs)
};
export { top_ups_modal_total_to_pay_label as "top_ups.modal.total_to_pay_label" }